import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import type { ILeadBulkDeleteDialogProps } from '@/@types/leads';

export const LeadBulkDeleteDialog = ({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
  count,
}: ILeadBulkDeleteDialogProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            Delete {count} Lead{count !== 1 ? 's' : ''}?
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to delete{' '}
            <span className="font-semibold">
              {count} lead{count !== 1 ? 's' : ''}
            </span>
            ? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>

        <div className="rounded-md bg-destructive/10 p-4 text-sm text-destructive">
          <p className="font-medium mb-1">Warning:</p>
          <ul className="list-disc list-inside space-y-1">
            <li>All conversations and messages will be permanently deleted</li>
            <li>
              All notifications for {count !== 1 ? 'these leads' : 'this lead'} will be removed
            </li>
            <li>This action cannot be undone</li>
          </ul>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? 'Deleting...' : `Delete ${count} Lead${count !== 1 ? 's' : ''}`}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
